const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const setScrolledState = () => {
  document.documentElement.classList.toggle('vp-scrolled', window.scrollY > 24);
};

setScrolledState();
window.addEventListener('scroll', setScrolledState, { passive: true });

if (!reducedMotion.matches) {
  document.documentElement.classList.add('vp-motion-ready');

  const revealTargets = document.querySelectorAll(
    [
      '#MainContent > .shopify-section',
      '.haomaison-featured-card',
      '.haomaison-category',
      '.product-card',
      '.haomaison-product-guide__card',
      '.haomaison-collection-guide__step',
      '.haomaison-proof-notes__card',
    ].join(',')
  );

  revealTargets.forEach((element, index) => {
    element.dataset.vpReveal = '';
    element.style.setProperty('--vp-reveal-index', String(index % 6));
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12,
    }
  );

  revealTargets.forEach((element) => observer.observe(element));
}
